module.exports = __webpack_public_path__ + "img/ranking1.56abac41.png";